import { buildProcessingStatus, buildReviewStatus } from "@/lib/semanticColors";

/**
 * Single source of truth per status: `REVIEW_STATUSES` (the display list) and
 * `REVIEW_STATUS` (the id map code branches on) are both derived from this, so
 * an id is only ever written once. Previously the two were hand-typed
 * separately and nothing stopped them from drifting apart.
 */
const REVIEW_STATUS_DEFS = [
  { key: "NEW", id: 1, label: "New" },
  { key: "DATA_EXTRACTED", id: 2, label: "Data Extracted" },
  { key: "AI_APPROVED", id: 3, label: "AI Approved" },
  { key: "REVIEW_REQUIRED", id: 4, label: "Review Required" },
  { key: "REVIEWED", id: 5, label: "Reviewed" },
  { key: "APPROVAL_REQUIRED", id: 6, label: "Approval Required" },
  { key: "APPROVED", id: 7, label: "Approved" },
  { key: "REJECTED", id: 8, label: "Rejected" },
];

const PROCESSING_STATUS_DEFS = [
  { key: "NEW", id: 1, label: "New" },
  { key: "UNDER_REVIEW", id: 2, label: "Under Review" },
  { key: "READY_FOR_PROCESSING", id: 3, label: "Ready For Processing" },
  { key: "PROCESSING", id: 4, label: "Processing" },
  { key: "SUCCESSFUL", id: 5, label: "Successful" },
  { key: "FAILED", id: 6, label: "Failed" },
  { key: "IN_QUERY", id: 7, label: "In Query" },
  { key: "AWAITING_CREDIT_NOTE", id: 8, label: "Awaiting Credit Note" },
  { key: "PART_INVOICED", id: 9, label: "Part-invoiced" },
  { key: "UPFRONT", id: 10, label: "Upfront" },
];

export const REVIEW_STATUSES = REVIEW_STATUS_DEFS.map(({ id, label }) =>
  buildReviewStatus(id, label),
);

export const PROCESSING_STATUSES = PROCESSING_STATUS_DEFS.map(({ id, label }) =>
  buildProcessingStatus(id, label),
);

/** Numeric ids the API uses, keyed the way code branches on them. */
export const REVIEW_STATUS = Object.fromEntries(
  REVIEW_STATUS_DEFS.map(({ key, id }) => [key, id]),
);

export const PROCESSING_STATUS = Object.fromEntries(
  PROCESSING_STATUS_DEFS.map(({ key, id }) => [key, id]),
);
